import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Trophy } from "lucide-react";
import SEO from './SEO';
import {
  ArrowRight,
  Phone,
  ChevronDown,
  ChevronUp,
  CheckCircle2,
} from 'lucide-react';

import Gallery36 from '../images/compressed-images (3)/Gallery36.jpg';

// Import images 
import heroImage from '../images/medical-orthopedic-sports-clinic-modern-facility.jpg';
import arthroscopyImage from '../images/arthroscopy-knee-surgery-minimally-invasive.jpg';
import sportsInjuryImage from '../images/sports-injury-athlete-treatment-rehabilitation.jpg';
import fractureImage from '../images/fracture-trauma-xray-bone-treatment.jpg';
import jointReplacementImage from '../images/joint-replacement-knee-hip-surgery.jpg';
import jointCareImage from '../images/shoulder-knee-hip-joint-care-examination.jpg';
import physiotherapyImage from '../images/physiotherapy-rehabilitation-exercise-recovery.jpg';
import doctorImage from '../images/orthopedic-doctor-consultation-professional-medica.jpg';
import Shoulderarthroscopy from '../images/Shoulderarthroscopy.jpg'
import Shoulderarthroscopyprocedure from '../images/Shoulderarthroscopyprocedure.jpg'
import Plastercastingprocedure from '../images/Plastercastingprocedure.jpg'
import Wristarthroscopyprocedure from '../images/Wristarthroscopyprocedure.jpg'
import Shoulderarthroscopyprocedure2 from '../images/Shoulderarthroscopyprocedure-2.jpg'
import Shoulderarthroscopyprocedure3 from '../images/Shoulderarthroscopyprocedure-3.jpg'
import telanganaarthroscopysociety from '../images/Faculty-at-telangana-arthroscopy.jpg'
import hyderabadarthroscopy from '../images/hyderabad-arthroscopy-conclave-2025.jpg'
import telanganaorthopaedic from '../images/telangana-orthopaedic-surgeon-association-conference-2025.jpg'
import Tosacon2025 from '../images/TOSACON-2025.jpg'
import Germany2024 from '../images/germany-2024.jpg'
import Wristarthroscopyprocedure2 from '../images/Wristarthroscopyprocedure-2.jpg'
import WithDrlorenzomerlini from '../images/WithDrlorenzomerlini.jpg'
import WithDrahlamArnout from '../images/WithDrahlamArnout.jpg'
import Tosacon2024 from '../images/FacultyatTASCON2024.jpg'
import carpometarpal from '../images/carpometarpaljointarthroscopy.jpg'
import arthroplastyworkshop from '../images/arthroplastyworkshop.jpg'
import HandMicrosurgery from '../images/Hand&Microsurgery.jpg'
import nephewacademy from '../images/nephewacademy.jpg'
import clinicphoto from '../images/Clinicphoto.jpg'
import Opdconsultation from '../images/Opdconsultation.jpg'
import TotalKneeReplacement from '../images/Totalkneereplacement.jpg'
import MedicalCamps from '../images/MedicalCamps.jpg'
import FootAnkel from '../images/Foot&Ankle.jpg'
import HandWrist from '../images/Hand&Wrist.jpg'

export default function HomePage() {
  const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Advanced Orthopedic Treatments for Joint Pain and Injuries",
  "description":
    "Learn about advanced orthopedic treatments including knee replacement, hip replacement, and sports injury management by Dr. Sujit Kumar, leading orthopedic surgeon in Hyderabad.",
  "image": "https://www.drsujitkumar.com/images/dr-sujit-kumar.jpg",
  "author": {
    "@type": "Person",
    "name": "Dr. Sujit Kumar",
    "url": "https://www.drsujitkumar.com/"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Dr. Sujit Kumar Orthopedic Clinic",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.drsujitkumar.com/images/logo.png"
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://www.drsujitkumar.com/"
  },
  "datePublished": "2024-01-01",
  "dateModified": "2025-01-01"
};

  const services = [
    {
      image: arthroscopyImage,
      title: "Arthroscopy",
      description:
        "Minimally invasive procedures for Knee, Shoulder, Wrist joint including ACL, Meniscus, Rotator cuff repairs,Glenoid labral repairs , tfcc tears and Scapholunate tears",
      href: "/treatments/arthroscopy",
    },
    {
      image: sportsInjuryImage,
      title: "Sports Injury Management",
      description: "Comprehensive care from acute injuries to structured return-to-play programs.",
      href: "/treatments/sports-injuries",
    },
    {
      image: fractureImage,
      title: "Fracture & Trauma Care",
      description: "Emergency and planned fracture treatment with surgical fixation and rehabilitation.",
      href: "/treatments/fractures-trauma",
    },
    {
      image: jointReplacementImage,
      title: "Joint Replacement",
      description: "Total and partial replacement for Knee, Hip, Shoulder,Elbow and Hand ( 1st cmc and ip joints) with personalized recovery.",
      href: "/treatments/joint-replacement",
    },
    {
      image: jointCareImage,
      title: "Shoulder & Knee",
      description: "Focused clinics for joint pain evaluation, injections, and surgical options.",
      href: "/treatments/shoulder-knee-hip",
    },
    {
      image: physiotherapyImage,
      title: "Physiotherapy & Rehab",
      description: "Post-injury and post-surgery rehabilitation with sport-specific conditioning.",
      href: "/treatments/physiotherapy-rehab",
    },
    {
      image: FootAnkel,
      title: "Foot & Ankle",
      description: "Expert care for all foot and ankle injuries and conditions.",
      href: "/treatments/foot-ankle",
    },
    {
      image: HandWrist,
      title: "Hand & Wrist",
      description: "Specialized care for hand and wrist pain, injuries, and disorders.",
      href: "/treatments/hand-wrist",
    },
    {
      image: MedicalCamps,
      title: "Medical Camps",
      description: "Community health camps and screening programs for early detection and prevention.",
      href: "/treatments/medical-camps",
    },
  ];

  // WHY CHOOSE DATA
  const benefitsData = [
    {
      title: "Specialized Expertise",
      content:
        "Led by Dr. Sujitkumar Vakati R, an internationally trained Orthopaedic Surgeon with advanced fellowships from Japan, Germany, and Paris, offering super-specialized care in Joints, Hand & Wrist, Arthroscopy, and Sports Injuries.",
    },
    {
      title: "Comprehensive Orthopaedic Care",
      content:
        "From joint pain evaluation to arthroscopy, fracture fixation, ligament reconstruction, and total joint replacement, the clinic provides full-spectrum orthopaedic solutions under one roof.",
    },
    {
      title: "Advanced Hand & Wrist Centre",
      content:
        "Dedicated centre for hand and wrist fractures, ligament tears, stiffness, and wrist arthroscopy — backed by advanced fellowship training.",
    },
    {
      title: "Sports Injury & Arthroscopy Excellence",
      content:
        "Advanced arthroscopy and minimally invasive procedures for shoulder, knee, elbow, and wrist injuries with FIFA & IOC–based rehab.",
    },
    {
      title: "Joint Replacement Expertise",
      content:
        "Specialized in total knee, shoulder, and elbow replacements with precision implant planning and rapid recovery protocols.",
    },
    {
      title: "Rehabilitation & Return-to-Play Programs",
      content:
        "Structured physiotherapy with custom return-to-sport and return-to-work plans for athletes, professionals, and seniors.",
    },
    {
      title: "Ethical, Patient-Centric Approach",
      content:
        "Transparent diagnosis, honest recommendations, and individualized treatment plans without unnecessary procedures.",
    },
    {
      title: "Collaborative Multispecialty Network",
      content:
        "Integrated care with sports physicians, physiotherapists, nutrition experts, and radiologists.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <>
    <SEO
  title="Dr. Sujit Kumar | Best Orthopedic & Joint Replacement Surgeon in Hyderabad"
  description="Dr. Sujit Kumar is a leading orthopedic and joint replacement surgeon in Hyderabad, specializing in knee replacement, hip replacement, sports injuries, and advanced orthopedic care."
  keywords="Dr Sujit Kumar, orthopedic doctor Hyderabad, best orthopedic surgeon Hyderabad,
            joint replacement surgeon Hyderabad, knee replacement Hyderabad,
            hip replacement Hyderabad, sports injury doctor Hyderabad,
            orthopedic clinic Hyderabad, bone specialist Hyderabad"
  canonical="https://www.drsujitkumar.com/"
  robots="index, follow"
  author="Dr. Sujit Kumar"
  publisher="Dr. Sujit Kumar"
  schema={articleSchema}
/>

    <div className="min-h-screen flex flex-col">
      <Header />

      {/* HERO */}
      <section className="relative bg-gradient-to-br from-primary via-primary to-primary/90 text-primary-foreground">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="relative mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold sm:text-6xl font-playfair">
              Joint,Hand & Sports Surgeon You Can Trust
            </h1>
            <p className="mt-6 text-lg text-primary-foreground/90">
              Advanced diagnosis, precise treatment, and faster recovery for bones, joints and sports injuries.
            </p>
            <div className="mt-10 flex items-center gap-4 flex-wrap">
              <Button size="lg" variant="secondary" asChild>
                <Link to="/book-appointment">
                  Book Appointment
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>

              <Button
                size="lg"
                variant="outline"
                className="border-primary-foreground text-secondary-foreground hover:bg-primary-foreground hover:text-primary"
                asChild
              >
                <a href="tel:+919989345545">
                  <Phone className="mr-2 h-5 w-5" />
                  Call Now
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold sm:text-4xl mb-6 font-playfair">
              Comprehensive Orthopaedic Care
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              At Orthopaedic & Sports Injury Clinic, we provide comprehensive care for joint pain, fractures, ligament
              injuries and post-operative rehabilitation.
            </p>
          </div>
        </div>
      </section>

   {/* Awards and Achievements */}
<section className="py-0 md:py-20 bg-muted/30">
  <div className="mx-auto max-w-7xl px-6 lg:px-8">
    
    <div className="mx-auto max-w-3xl text-center mb-12">
      <h2 className="text-5xl font-bold tracking-tight mb-6 font-[family-name:var(--font-playfair)]">
        Awards & Acheivements
      </h2>
      <p className="text-lg text-muted-foreground">
        Dr. Sujit Kumar has been honored with numerous prestigious awards for excellence in healthcare and orthopaedics.
      </p>
    </div>

{/* ⭐️⭐️⭐️ Scrolling Awards Gallery ⭐️⭐️⭐️ */}
<div className="mt-8 relative">

  {/* Left Button */}
  <button
    onClick={() =>
      document.getElementById("awardsScroll").scrollBy({
        left: -300,
        behavior: "smooth",
      })
    }
    className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white shadow-lg rounded-full p-2"
  >
    ◀
  </button>

  {/* Right Button */}
  <button
    onClick={() =>
      document.getElementById("awardsScroll").scrollBy({
        left: 300,
        behavior: "smooth",
      })
    }
    className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white shadow-lg rounded-full p-2"
  >
    ▶
  </button>

  {/* Scroll Container (NO SCROLLBAR) */}
  <div
    id="awardsScroll"
    className="flex gap-6 overflow-x-hidden scroll-smooth py-3"
    style={{ scrollBehavior: "smooth" }}
  >
    {[
      { src: TotalKneeReplacement, title: "Total Knee Replacement" },
      { src: Shoulderarthroscopy, title: "Shoulder Arthroscopy Updates at France 2025" },
      { src: Shoulderarthroscopyprocedure, title: "Shoulder Arthroscopy Procedure" },
      { src: Plastercastingprocedure, title: "Plaster Casting Procedure" },
      { src: Wristarthroscopyprocedure, title: "Wrist Arthroscopy Procedure" },
      { src: Shoulderarthroscopyprocedure2, title: "Shoulder Arthroscopy Procedure" },
      { src: telanganaarthroscopysociety, title: "Faculty at Telangana Arthroscopy Society Conference 2025" },
      { src: hyderabadarthroscopy, title: "Faculty at Hyderabad Arthroscopy Conclave 2025" },
      { src: telanganaorthopaedic, title: "Faculty at Telangana Orthopaedic Surgeon Association Conference 2025" },
      { src: Shoulderarthroscopyprocedure3, title: "Shoulder Arthroscopy Procedure" },
      { src: Tosacon2025, title: "Faculty at TOSACON 2025" },
      { src: Germany2024, title: "Visit to Germany - Regenerative Medicine Discussion" },
      { src: Wristarthroscopyprocedure2, title: "Wrist Arthroscopy Procedure" },
      { src: WithDrlorenzomerlini, title: "With Dr. Lorenzo Merlini – Fellowship, Paris" },
      { src: WithDrahlamArnout, title: "With Dr. Ahlam Arnout – Fellowship, Paris" },
      { src: Tosacon2024, title: "Faculty at TASCON 2024" },
      { src: carpometarpal, title: "1st Carpometarpal Joint Arthroscopy Procedure" },
      { src: arthroplastyworkshop, title: "1st CMC Joint Arthroplasty Workshop, France 2025" },
      { src: HandMicrosurgery, title: "Hand & Microsurgery" },
      { src: nephewacademy, title: "At Smith & Nephew Academy, Singapore" },
      { src: clinicphoto, title: "Clinic Photo" },
      { src: Opdconsultation, title: "OPD Consultation" },
    ].map((image, index) => (
      <div
        key={index}
        className="relative group w-72 h-64 flex-shrink-0 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
      >
        <img
          src={image.src}
          alt={image.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 px-4 py-3">
            <h3 className="text-white text-sm font-semibold leading-snug">
              {image.title}
            </h3>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>
{/* ⭐️ END Scrolling Gallery ⭐️ */}





    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-16">
      {/* Left Column - Major Awards */}
      <div className="space-y-6">
        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Telanagana Arthroscopy Society Conference 2025 - SPEAKER & PANELIST, MODERATOR
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Telangana Orthopaedic Surgeons Associtation State Conference 2025 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Telangana Orthopaedic Surgeons Association Pre-Conference Workshop 2025 - ORGANISING SECRETARY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Telangana Arthroscopy Society Conference 2024 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Hyderabad Fracture Fixation Course 2023 - GUEST FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                ISSH Basic Hand Course 2023 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                TCOS MEET - 3D BIOPRINTING in Orthopaedics 2023 - GUEST LECTURE
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Right Column */}
      <div className="space-y-6">
        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                TOSACON 2023 – PANELIST (Shoulder, Hand & Wrist Sessions)
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                TOSACON Hand & Wrist Workshop 2023 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                TKR Live Surgery & Workshop 2023 - ORGANISING SECRETARY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                AO Trauma Blended Course 2021 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                1st Hip Arthroscopy Conference 2019 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>

        <Card className="border shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="py-0 px-4 sm:py-4 sm:px-6 flex gap-4">
            <div className="flex-shrink-0">
              <Trophy className="h-8 w-8 text-red-600" />
            </div>
            <div>
              <p className="text-foreground leading-relaxed">
                Arthroscopy Simulation Courses at GSL SMART LAB 2016–2018 - FACULTY
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>

  </div>
</section>


      {/* SERVICES */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-bold sm:text-4xl mb-4 font-playfair">Our Services</h2>
            <p className="text-lg text-muted-foreground">Expert treatment across all aspects of orthopaedic care</p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service, index) => (
              <Card key={index} className="group hover:shadow-lg transition overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="object-cover w-full h-full group-hover:scale-105 transition duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <h3 className="absolute bottom-4 left-4 text-xl text-white">{service.title}</h3>
                </div>
                <CardContent className="p-6">
                  <p className="text-muted-foreground mb-4 leading-relaxed">{service.description}</p>
                  <Link to={service.href} className="inline-flex items-center text-primary">
                    Learn more <ArrowRight className="ml-1 h-4 w-4" />
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE — CLEAN ACCORDION */}
      <section className="py-20 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* LEFT */}
            <div>
              <h2 className="text-3xl font-bold sm:text-3xl mb-6 font-playfair">
                Why Choose Dr. Sujitkumar Vakati R’s Orthopaedic & Sports Injury Clinic

              </h2>

              <p className="text-lg text-muted-foreground mb-8 leading-relaxed max-w-xl">
                We are committed to providing the highest standard of orthopaedic care with a patient-centered approach.
              </p>

              <div className="space-y-5">
                {benefitsData.map((item, index) => (
                  <div key={index} className="space-y-2">

                    <button
                      onClick={() => toggle(index)}
                      className="flex items-center justify-between w-full text-left"
                    >
                      <span className="flex items-center gap-3 text-lg font-medium">
                        <CheckCircle2 className="h-6 w-6 text-primary" />
                        {item.title}
                      </span>

                      {openIndex === index ? (
                        <ChevronUp className="h-5 w-5 text-primary" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-primary" />
                      )}
                    </button>

                    {openIndex === index && (
                      <p className="text-muted-foreground leading-relaxed pl-9">
                        {item.content}
                      </p>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-8">
                <Button size="lg" asChild>
                  <Link to="/about">
                    Meet Dr. Sujit Kumar <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="relative h-[400px] lg:h-[500px] rounded-xl overflow-hidden shadow-xl">
              <img
                src={Gallery36}
                alt="Dr. Sujit Kumar consulting with patient"
                className="object-cover w-full h-full"
              />
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-secondary text-secondary-foreground">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold sm:text-4xl mb-4 font-playfair">
            Ready to Start Your Recovery?
          </h2>
          <p className="text-lg mb-8 text-secondary-foreground/90 max-w-2xl mx-auto">
            Book an appointment today and take the first step toward pain-free movement.
          </p>

          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Button size="lg" variant="secondary" className="bg-primary-foreground text-primary" asChild>
              <Link to="/book-appointment">Book Appointment</Link>
            </Button>

            <Button
              size="lg"
              variant="outline"
              className="border-secondary-foreground text-secondary-foreground hover:bg-secondary-foreground hover:text-secondary"
              asChild
            >
              <Link to="/contact">Contact Us</Link>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
    </>
  );
}
